// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import pkbEntity from './entities/pkb.json';
import pkbMenu from '../pages/pkb/menu.json';
import pkbFullForm from '../pages/pkb/forms/full.json';
import pkbContextForm from '../pages/pkb/forms/context.json';
import pkbMiniForm from '../pages/pkb/forms/mini.json';
import pkbLookupForm from '../pages/pkb/forms/lookup.json';
import pkbTableView from '../pages/pkb/views/table.json';
import pkbStagesView from '../pages/pkb/views/stages.json';
import pkbCardsView from '../pages/pkb/views/cards.json';
import pkbInlineView from '../pages/pkb/views/inline.json';
import pkbBacklogView from '../pages/pkb/views/backlog.json';
import pkbSplitView from '../pages/pkb/views/split.json';
import pkbCalendarView from '../pages/pkb/views/calendar.json';
import pkbDashboardView from '../pages/pkb/views/dashboard.json';

/** Тип запису «Стаття» зі сторінками пакета: меню, форми та подання з pages/pkb/. */
export const pkbDefinition: IRecordTypeDefinition = {
  ...pkbEntity,
  views: assembleViewSet({
      table: pkbTableView,
      stages: pkbStagesView,
      cards: pkbCardsView,
      inline: pkbInlineView,
      backlog: pkbBacklogView,
      split: pkbSplitView,
      calendar: pkbCalendarView,
      dashboard: pkbDashboardView,
  }),
  form: pkbFullForm,
  forms: { full: pkbFullForm, context: pkbContextForm, mini: pkbMiniForm, lookup: pkbLookupForm },
  menu: pkbMenu,
} as IRecordTypeDefinition;
